import { NotificationDataBuilder } from '../notifications-classes'

export class BookedEventNotification extends NotificationDataBuilder {
  constructor(props) {
    super(props)
    this.onClick = (item) => {
      console.log('The onClick of the BookedEventNotification class has not been set.')
    }
  }
  setOnClick(functionSet) {
    this.onClick = functionSet
  }
}
